import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { UnidataTable } from '~/components'
import { Input } from '~/components/Form'

import { isEmpty, find } from 'lodash'

import { recordFiltering } from '~/store/modules/auditoriaItem/actions'
import * as S from './styles'


export default function DetalhesAuditoria(props) {



    const [query, setQuery] = useState({
    })



    const [usua_login, setUsua_login] = useState('')

    const data = useSelector((state) => state.auditoriaitem)

    const optionsAlter = useMemo(() => [
        { label: 'S', value: 'Sim' },
        { label: 'N', value: 'Não' },
    ], []);




    useEffect(() => {

        if (props.data) {
            setUsua_login(props.data.usua_login)
            setQuery({
                wherefield: ['ausi_codigo'],
                valuewherefield: [props.data.ausi_codigo],
                typewherefield: ['EQUALS'],
                pagesize: 99999,
                page: 1
            })
        }
    }, [props])

    const handleFormatAcao = useCallback((value) => {
        let objectAcao = find(optionsAlter, (item) => item.label == value)
        return objectAcao.value
    }, [optionsAlter])

    const header = useMemo(() => {

        if (props.data.ausi_acao == "I") {
            return [                
                { id: 'aust_campo_label', label: 'Campo', filter: { type: 'text' } },                
                { id: 'aust_descricao_valor_novo', label: 'Dados Novo', filter: { type: 'text' } },                
            ]
        }  
        
        
        if (props.data.ausi_acao == "R") {
            return [
                { id: 'aust_campo_label', label: 'Campo', filter: { type: 'text' } },                
                { id: 'aust_valor_novo', label: 'Valor', filter: { type: 'text' } },
            ]
        }


        if (props.data.ausi_acao == "C") {
            return [
                { id: 'aust_campo_label', label: 'Campo', filter: { type: 'text' } },
                { id: 'aust_valor_anterior', label: 'Operador', filter: { type: 'text' } },
                { id: 'aust_valor_novo', label: 'Valor', filter: { type: 'text' } },
            ]
        }

        if (props.data.ausi_acao == "E") {
            return [                
                { id: 'aust_campo_label', label: 'Campo', filter: { type: 'text' } },                
                { id: 'aust_descricao_valor_novo', label: 'Dados', filter: { type: 'text' } },                
            ]
        } 

        if (props.data.ausi_acao == "O") {
            return [                
                { id: 'aust_campo_label', label: 'Campo', filter: { type: 'text' } },                
                { id: 'aust_descricao_valor_novo', label: 'Dados', filter: { type: 'text' } },                
            ]
        } 


        return [
            // { id: 'ausi_codigo', label: 'Código da Auditoria', filter: { type: 'text' } },
            // { id: 'aust_codigo', label: 'Código do Item Auditoria', filter: { type: 'text' } },
            { id: 'aust_campo_label', 
                label: 'Campo', 
                filter: { type: 'text' },
                styled: (v) => (v.dif_campo_auditoria_item === 'S' ? {  color: 'red' } : {}),
            },
            //{ id: 'aust_valor_anterior', label: 'Dados Anterior', filter: { type: 'text' } },
            
            { id: 'aust_descricao_valor_anterior', 
                label: 'Dados Anterior', 
                filter: { type: 'text' }, 
                styled: (v) => (v.dif_campo_auditoria_item === 'S' ? {  color: 'red' } : {}),
            } ,
            //  styled: () => (  { color: 'red'} )
            
            //{ id: 'aust_valor_novo', label: 'Dados Novo', filter: { type: 'text' } },
            { id: 'aust_descricao_valor_novo', 
               label: 'Dados Novo', 
               filter: { type: 'text' },
               styled: (v) => (v.dif_campo_auditoria_item === 'S' ? {  color: 'red' } : {}), },
            {
                id: 'dif_campo_auditoria_item',
                label: 'Foi alterado',
                styled: (v) => (v.dif_campo_auditoria_item === 'S' ? {  color: 'red' } : {}),
                filter: { type: 'select', options: optionsAlter },
                formatted: (value) => handleFormatAcao(value)
            }
        ]
    }, [])


    return (
        <S.DefaultContainer>
            {props.data && <S.headerContainer >
                <Input name="usuario" label="Usuário" value={props.data.usua_login} disabled />
                <Input name="perfil" label="Perfil Usuário" value={props.data.perf_descricao} disabled />
                <Input name="acao" label="Ação" value={props.data.ausi_acao_string} disabled />
                <Input name="modulo" label="Módulo" value={props.data.ausi_modulo_descricao} disabled />
                <Input name="chave" label="Chave" value={props.data.ausi_chave} disabled />
            </S.headerContainer>}
            <S.ContainerTable>
                <S.ContentTable >
                    {!isEmpty(query) && <UnidataTable
                        // fixed                        
                        dense
                        update={false}
                        create={false}
                        delete={false}
                        query={query}
                        header={header}
                        redux={data}
                        keys="aust_campo_label"
                        detach="aust_campo_label"
                        read={recordFiltering}
                        maxHeight={'100%'}
                    />}
                </S.ContentTable>
            </S.ContainerTable>
        </S.DefaultContainer>



    )
}